import CreditApplicationFail from 'features/believe/application/CreditApplicationFail/CreditApplicaitonFail';
import React from 'react';

export default function CardApplicationFailPage() {
  return <CreditApplicationFail />;
}
